
(async function () {

  // Handle Model Form
  const modelForm = document.getElementById('model-form');

  if (modelForm == undefined) {
    console.log('Model form does not exist')
  } else {
    const myHeaders = new Headers();
    myHeaders.append('x-api-key', '6XHzlHGCFQ96QW6f4uxN44HCpGvXJf2yL7WN5XSg');
    myHeaders.append('Content-Type', 'application/json');

    let brandsList;

    /**
     * Get all Brands
     * @returns 
     */
    async function getBrandsList() {
      return new Promise(async (resolve, reject) => {
        const brands = await fetch('https://apis.needapart.co.nz/brands', {
          method: 'GET',
          credentials: 'same-origin',
          redirect: "follow",
          headers: myHeaders,
        }).then(res => res.json())
          .catch(e => reject(e));

        resolve(brands?.brands);
      })
    }

    /**
     * Get Models based on Appliance Type & Brand
     * @param {*} brand 
     * @returns 
     */
    async function getModelsList(brand) {
      const models = await fetch(`https://apis.needapart.co.nz/models?brand=${brand}`, {
        method: 'GET',
        credentials: 'same-origin',
        redirect: "follow",
        headers: myHeaders,
      }).then(res => res.json())
        .catch(e => console.log(e))
      
      return models.models;
    }

    /**
     * Populate Models based oon Appliance Type & Brand
     * @param {*} applianceValue 
     * @param {*} brandValue 
     */
    async function populateModels(brandValue) {
      modelForm.classList.add('loadingOverlay');
      const selectedBrand = brandsList.filter(brand => brand.brand === brandValue);

      const models = await getModelsList(brandValue);
      
      if (models.length > 0) {
        const modelsEl = document.createElement('div');
        models.forEach(el => {
          modelsEl.insertAdjacentHTML('beforeend', `<option>${el.model}</option>`);
        });

        document.getElementById('modelList').innerHTML = modelsEl.innerHTML;

      } else {
        document.getElementById('modelList').innerHTML = '';
        document.getElementById('modelNo').value = '';
      }
      modelForm.classList.remove('loadingOverlay');
    }


    function init() {
      const promiseArr = []; // Empty array to push all async fns
      const brandsInput = document.getElementById('brands');

      // Add Loader on load
      modelForm.classList.add('loadingOverlay');

      promiseArr.push(getBrandsList());

      Promise.all(promiseArr)
        .then(res => {
          // Populate Brands
          const brandsEl = document.createElement('div');
          brandsList = res[0];
          brandsList.forEach(el => {
            brandsEl.insertAdjacentHTML('beforeend', `<option value="${el.brand}">${el.brand}</option>`);
          });

          document.getElementById('brandList').innerHTML = brandsEl.innerHTML;

          // Remove Loader
          modelForm.classList.remove('loadingOverlay');
        })
        .then(() => {
          // Check if values for both appliance type and brand are pre loaded
          if (brandsInput.value !== "") {
            populateModels(brandsInput.value);
          }
        })
        .catch(e => console.log(e));
    }

    // Initialize
    init();

    // Listen to change in any of the 3 input values
    modelForm.addEventListener('change', async e => {
      const brandValue = modelForm.querySelector('#brands').value;

      if ((e.target.id == 'brands') && brandValue !== '') {
        populateModels(brandValue);
      }
    });
  }
})();